import React, { useState } from 'react';
import axios from 'axios';
import { Send } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputCls = 'mt-2 w-full px-4 py-3 rounded-xl bg-[#0a0e16] border border-white/10 text-white placeholder:text-[#6b7384] focus:outline-none focus:border-[#e8743b]/60 transition-colors';

const ContactForm = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();
  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast({ title: 'Missing details', description: 'Please complete all fields.' });
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast({ title: 'Message sent!', description: 'Thanks for reaching out - we will reply soon.' });
      setForm({ name: '', email: '', message: '' });
    } catch (err) {
      const detail = err?.response?.data?.detail || 'Something went wrong. Please try again.';
      toast({ title: 'Could not send', description: typeof detail === 'string' ? detail : 'Please check your details.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dctv-card rounded-2xl p-8">
      <form onSubmit={submit} className="space-y-5">
        <label className="block">
          <span className="text-[#cdd2dc] text-sm font-medium">Name</span>
          <input value={form.name} onChange={onChange('name')} placeholder="Your name" className={inputCls} />
        </label>
        <label className="block">
          <span className="text-[#cdd2dc] text-sm font-medium">Email</span>
          <input type="email" value={form.email} onChange={onChange('email')} placeholder="you@example.com" className={inputCls} />
        </label>
        <label className="block">
          <span className="text-[#cdd2dc] text-sm font-medium">Message</span>
          <textarea value={form.message} onChange={onChange('message')} rows={5} placeholder="How can we help?" className={`${inputCls} resize-none`} />
        </label>
        <button type="submit" disabled={loading} className="dctv-btn-primary inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-[15px] font-semibold disabled:opacity-60">
          <Send className="w-4 h-4" /> {loading ? 'Sending…' : 'Send message'}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
